export default "__VITE_ASSET__DbhfNH43__"